
















































































import Vue from 'vue'
import Component from 'vue-class-component'
import JobListingTerm from './JobListingTerm.vue'
import { JobListing } from '../utils/types'
import { Prop } from 'vue-property-decorator'

@Component({
  components: { JobListingTerm }
})
export default class JobListingDialog extends Vue {
  @Prop(Object) readonly jobListing!: JobListing;
  tab = 0;
  emitClose () {
    this.$emit('close')
  }

  parseTime (timeStart: string, timeEnd: string): string {
    if (!timeStart || !timeEnd) {
      return ''
    }
    const [startHour, startMinute] = new Date(timeStart).toTimeString().split(':')
    const [endHour, endMinute] = new Date(timeEnd).toTimeString().split(':')
    return `${endHour}:${endMinute} - ${startHour}:${startMinute}`
  }
}
